var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"jin-icon",class:[("jin-icon-" + _vm.name)],style:({'color': _vm.color}),on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }